/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { OptionCodeAnts } from '@/types';

/**
 * Garantit que le code ANTS actuellement affecté à la mention a une entrée dans
 * les options du dropdown « Code ANTS » — une catégorie caduque, par exemple,
 * n'y est plus proposée mais doit rester lisible.
 */
const completerOptionsCodeAnts = (
  options: OptionCodeAnts[],
  codeMentionAnts: number | string | undefined | null,
  libelle?: string | null,
): OptionCodeAnts[] => {
  if (_.isNil(codeMentionAnts) || codeMentionAnts === '') {
    return options;
  }

  const identifiant = Number(codeMentionAnts);

  if (_.some(options, (option) => option.value === identifiant)) {
    return options;
  }

  return [
    ...options,
    {
      key: identifiant,
      value: identifiant,
      text: libelle || String(identifiant),
    },
  ];
};

export default completerOptionsCodeAnts;
